export default "__VITE_ASSET__CZFzLtLe__"